export const getLocalStorage = (key) => {
  try {
    return JSON.parse(
      localStorage.getItem(process.env.REACT_APP_TITLE + "_" + key),
    );
  } catch {
    return localStorage.getItem(process.env.REACT_APP_TITLE + "_" + key);
  }
};

export const setLocalStorage = (key, value) => {
  return localStorage.setItem(
    process.env.REACT_APP_TITLE + "_" + key,
    JSON.stringify(value),
  );
};

export const removeLocalStorage = (key) => {
  return localStorage.removeItem(process.env.REACT_APP_TITLE + "_" + key);
};

export const getSessionStorage = (key) => {
  try {
    return JSON.parse(
      sessionStorage.getItem(process.env.REACT_APP_TITLE + "_" + key),
    );
  } catch {
    return sessionStorage.getItem(process.env.REACT_APP_TITLE + "_" + key);
  }
};

export const setSessionStorage = (key, value) => {
  return sessionStorage.setItem(
    process.env.REACT_APP_TITLE + "_" + key,
    JSON.stringify(value),
  );
};

export const removeSessionStorage = (key) => {
  return sessionStorage.removeItem(process.env.REACT_APP_TITLE + "_" + key);
};
